<template>
  <div v-if="product">
    <img :src="photoUrl" alt />
    <h5 class="pageTitle">{{ product.name }}</h5>
    <vue-markdown class="product__description" :source="product.description" />

    <div class="pricesContainer">
      <div class="pricesSingle">
        Prix: {{ product.price | money }}
      </div>
    </div>

    <div class="buttonsContainer">
      <button
        class="btn btn-danger"
        @click="addProductToCart({ productId: product.id, quantity: '+' })"
      >
        Ajouter au panier
      </button>
      <router-link
        tag="button"
        class="btn btn-primary"
        :to="{ name: 'BoutiquePage' }"
      >
        Retour à la boutique
      </router-link>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: 'product-single',
    props: {
      product: {
        type: Object
      }
    },
    computed: {
      photoUrl() {
        if (
          this.product.photos &&
          Array.isArray(this.product.photos) &&
          this.product.photos[0]
        ) {
          return this.product.photos[0].url;
        }
        return 'https://via.placeholder.com/200x200';
      }
    },
    methods: {
      ...mapActions('orders', {
        addProductToCart: 'upsertProduct'
      })
    }
  };
</script>

<style lang="scss" scoped>
.buttonsContainer {
  text-align: center;
}

.buttonsContainer button {
  margin-top: 25px;
  margin-right: 10px;
}

.pricesSingle {
  font-size: 16px;
}

.pricesContainer {
  margin-top: 15px;
  margin-bottom: 20px;
  text-align: center;
}

img {
  display: block;
  margin: 50px auto 20px;
  height: 375px;
  max-width: 500px;
}

p {
  text-align: center;
}

.quantity {
  text-align: center;
}

.quantity input {
  width: 150px;
  margin: 0 auto;
}

.product {
  &__description {
    text-align: center !important;
  }
}
</style>
